var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8374 14.7933L20 17.9552L18.9552 19L15.7933 15.8374C14.6168 16.7805 13.1535 17.2935 11.6457 17.2913C7.97726 17.2913 5 14.3141 5 10.6457C5 6.97726 7.97726 4 11.6457 4C15.3141 4 18.2913 6.97726 18.2913 10.6457C18.2935 12.1535 17.7805 13.6168 16.8374 14.7933ZM15.3562 14.2454C16.2933 13.2817 16.8166 11.9899 16.8145 10.6457C16.8145 7.7895 14.5011 5.47681 11.6457 5.47681C8.7895 5.47681 6.47681 7.7895 6.47681 10.6457C6.47681 13.5011 8.7895 15.8145 11.6457 15.8145C12.9899 15.8166 14.2817 15.2933 15.2454 14.3562L15.3562 14.2454Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d04de83e1430f77376e7be0885c199ab.svg";
export { ForwardRef as ReactComponent };